import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper';
import BannerBlockItem, { BannerItemProps } from './BannerBlockItem';
import BannerBlock from './BannerBlock';
import clsx from 'clsx';

interface BannerBlockProps {
  slides: BannerItemProps[];
  numPerRow: number;
  systemId: string;
  fullwidth: boolean;
}

const BannerSliderBlock = ({
  systemId,
  slides,
  numPerRow,
  fullwidth,
}: BannerBlockProps) => {
  const [ready, setReady] = useState(false);

  useEffect(() => setReady(true), []);

  if (!slides || slides.length == 0) {
    return null;
  }

  return !ready || slides.length <= 1 ? (
    <BannerBlock
      numPerRow={numPerRow}
      banners={slides.slice(0, 1)}
      fullwidth={fullwidth}
      systemId={systemId}
    />
  ) : (
    <div
      className={clsx(
        'container [&_.swiper-button-next]:hidden [&_.swiper-button-next]:md:flex [&_.swiper-button-prev]:hidden [&_.swiper-button-prev]:md:flex',
        fullwidth && 'px-0',
        fullwidth && 'max-w-none',
        'overflow-x-hidden'
      )}
    >
      {ready && (
        <Swiper
          className={clsx('banner-swiper ', !fullwidth && 'rounded')}
          pagination={true}
          navigation={true}
          modules={[Pagination, Navigation]}
          lazy={true}
          loop={true}
        >
          {slides.map((slide: BannerItemProps, index: number) => (
            <SwiperSlide key={'banner-slider' + index + systemId}>
              <BannerBlockItem {...slide} />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
};

export default BannerSliderBlock;
